import { useCallback, useContext } from "react";
import { OverlayTriggerStateContext } from "react-aria-components";

import Button from "../Button";

type DrawerCancelButtonProps = {
  onClick?: () => void;
  disabled?: boolean;
  text?: string;
};

const DrawerCancelButton = ({ onClick, disabled, text = "Cancel" }: DrawerCancelButtonProps) => {
  const state = useContext(OverlayTriggerStateContext)!;

  const handleClick = useCallback(() => {
    state.close();
    onClick?.();
  }, [state, onClick]);

  return (
    <Button variant="secondary" onPress={handleClick} disabled={disabled}>
      {text}
    </Button>
  );
};

DrawerCancelButton.displayName = "DS.DrawerNew.CancelButton";

export default DrawerCancelButton;
